// extracted by mini-css-extract-plugin
module.exports = {"statusIconYes":"table_statusIconYes__S1c3u","statusIconNo":"table_statusIconNo__F3twX"};